import {ACCOUNT_BALANCE_CHANGED} from '@/store/money/accounts/mutation_types'

export default {
    [ACCOUNT_BALANCE_CHANGED]: (state, { accountId, balance }) => {
        const account = state.list.find(account => account.id === accountId)
        if (account) {
            account.balance = balance
        }
    }
}